import { type FC, memo } from 'react';
import cx from 'classnames';

import { type GenerationTool } from 'src/data/generationTool';

import { useStyles } from './useStyles';
import { getGenerationToolIcon } from './utils';

interface Props {
  className?: string;
  classes?: Partial<ReturnType<typeof useStyles>>;
  tool: GenerationTool;
}

export const GenerationToolIcon: FC<Props> = memo(({ className, classes, tool }) => {
  const styles = useStyles({ classes });
  const Icon = getGenerationToolIcon(tool);

  return <Icon className={cx(styles.root, className)} />;
});
